import React from "react";
import { useRefinementList } from "react-instantsearch";
import _ from "lodash";
import MenuItem from "@mui/material/MenuItem";
import { CheckBoxOutlineBlank, Done } from "@mui/icons-material";
import { Badge, Box } from "@mui/material";
import { AlgoliaRefinement } from "../../../types/Algolia/AlgoliaRefinement";
import { legalbirdRefinementListStyle } from "./legalbirdRefinementListStyle";

type LegalbirdRefinementListProps = {
  refinement: AlgoliaRefinement;
};
const LegalbirdRefinementList = (props: LegalbirdRefinementListProps) => {
  const { refinement } = props;
  const { staticItems, attribute } = refinement;
  const { items, refine } = useRefinementList({
    attribute: attribute.name,
    limit: Math.max(staticItems.length, 10),
  });

  const doRefine = (value: string) => {
    refine(value);
  };

  return (
    <Box sx={legalbirdRefinementListStyle.filterCategory}>
      <Box sx={legalbirdRefinementListStyle.categoryName}>{attribute.label}</Box>
      {_.map(staticItems, (staticItem) => {
        const item = _.find(items, ["label", staticItem.value]);
        const isRefined = !!item && item.isRefined;

        return (
          <MenuItem key={staticItem.value} sx={legalbirdRefinementListStyle.menuItem} onClick={() => doRefine(staticItem.value)}>
            {isRefined ? <Done /> : <CheckBoxOutlineBlank />}
            <Badge badgeContent={item?.count ?? 0} color={"primary"} showZero>
              <Box component="span" sx={legalbirdRefinementListStyle.itemLabel}>{staticItem.label}</Box>
            </Badge>
          </MenuItem>
        );
      })}
    </Box>
  );
};

export default LegalbirdRefinementList;
